export enum FeatureFlags {
    ORDINANCE_COMPANY = 'ORDINANCE_COMPANY',
    REPUBLIC_OF_GENOA = 'REPUBLIC_OF_GENOA'
}